import { customizeValidator } from '@rjsf/validator-ajv8';
import {
  DATE_DISABLED_FUNCTIONS,
  dateDisabledOptions,
} from '../katal/components/DatePicker/DatePickerHelper';

/**
 * Invalidate the dates not in format dd/mm/yyyy
 * @param date
 * @returns true for invalid dates and false for valid dates.
 */
export const invalidateDateNotInFormat = (date: string) => {
  const dateFormatRegex = new RegExp(customFormats['mm/dd/yyyy']);
  if (!dateFormatRegex.test(date)) {
    return true;
  }
  return false;
};

/**
 * Checks the below
 * 1. False for date in format: mm/dd/yyyy
 * 2. False for selected date more then (currentDate + 1).
 *
 * Current Date: 12/08/2024
 * Invalid Dates: 12/09/2024 and back
 * Valid Dates: 12/10/2024 onwards
 *
 * @param date //Expected format for date is dd/mm/yyyy
 * @returns true for invalid dates and false for valid dates.
 */
export const invalidateDatePlusOneDay = (date: string) => {
  if (!date || date.length < 10) {
    return true;
  }
  if (invalidateDateNotInFormat(date)) {
    return true;
  }

  //condition should be true for invalid dates.
  return !dateDisabledOptions(
    DATE_DISABLED_FUNCTIONS.DATE_LESS_THAN_TODAY_PLUS_1_DAY,
  )(new Date(date));
};

const customFormats = {
  'mm/dd/yyyy': '^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/(19|20)\\d{2}$',
  'dd/mm/yyyy': '^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/(19|20)\\d{2}$', //not in used.
  'invalidate-date-plus-one-day': invalidateDatePlusOneDay,
  'eu-amazon-url':
    /^https:\/\/(?:www.)?amazon.(?:fr|de|it|es|nl|se|com.be|pl|co.uk|ie)(\/.*)?$/,
  'list-of-emails':
    '^(?:([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})(\\s*,\\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})*)?$',
};

export const rjsfValidator = customizeValidator({ customFormats });
